/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { InputChip } from 'components/Fields';

const ColMatCode = () => {
  return <InputChip type="STITCH" name="stitch" label="Stitch" />;
};

export default ColMatCode;
